import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { useRouter } from "../../../../../routes/hooks";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IUserPassword } from "../../../../../types/user";
import { useBoolean } from "../../../../../hooks/use-boolean";
import { UpdateUserPasswordService } from "../../../../../services/users";
import { enqueueSnackbar } from "notistack";

const useUpdatePasswordUser = () => {

    const password = useBoolean();
    const router = useRouter();
    const { id } = useParams();

    const UpdatePasswordUserSchema = Yup.object().shape({
        password: Yup.string().min(6, 'A senha deve conter no mínimo 6 caracteres').required('Informe a senha do usuário').max(255, 'A senha deve conter no máximo 255 caracteres'),
        confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'As senhas não são iguais').required('Confirme a senha do usuário'),
    });

    const defaultValues = {
        password: '',
        confirmPassword: '',
    };

    const methods = useForm({
        resolver: yupResolver<IUserPassword>(UpdatePasswordUserSchema),
        defaultValues
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = handleSubmit(async (data: IUserPassword) => {

        await UpdateUserPasswordService(parseInt(id!), data).then(resp => {
            enqueueSnackbar(resp.data.message);
            router.push('/users');
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        })

    });

    return {
        onSubmit,
        isSubmitting,
        methods,
        password
    }

}

export default useUpdatePasswordUser;